import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import CardResource from '../../../molecules/profile/card-resource';
import CardResourceContainer from '../../../molecules/profile/card-resource-container';
import FooterDisclosures from '../../../atoms/footer-disclosures';
import HeaderQuoteBar from '../../../molecules/profile/header-quote-bar';
import InvestmentStrategy from '../../../molecules/profile/investment-strategy';
import PageHeader from '../../../molecules/profile/page-header';
import PageMain from '../../../molecules/profile/page-main';
import PageSideRail, { DisclosurePrint } from '../../../molecules/profile/page-side-rail';
import SectionDivider from '../../../atoms/section-divider';
import sectionDividerOptions from '../../../../helpers/statics/section-divider-options';
import useStore from '../../../../stores/profile/use-fdic-insured-bank-product-store';
import HistoricalRatesOfReturn from '../../../molecules/profile/historical-rates-of-return';
import { className } from '../../../../utils/GlobalCssProxy';
import { getIsDynamicGreetingShown } from '../../../molecules/profile/dynamic-greeting/dynamic-greeting-helper';

const FdicInsuredBankProduct = () => {
  const store = useStore();
  const quoteData = store.quote.isLoaded ? store.quote.data : {};
  const participantHoldingsData =
    store.participantHoldings && store.participantHoldings.isLoaded
      ? store.participantHoldings.data
      : {};
  const showDynamicGreeting =
    participantHoldingsData && getIsDynamicGreetingShown(participantHoldingsData);
  const disclosureList = store.disclosureList.isLoaded ? store.disclosureList.data : [];
  return (
    <div data-template="FDICInsuredBankProduct">
      <PageHeader
        displayAsFundType="FDIC Insured Bank Product"
        sectionNavOptions={[
          sectionDividerOptions.performance,
          sectionDividerOptions.characteristics,
          sectionDividerOptions.resources
        ]}
      >
        <HeaderQuoteBar>
          <HeaderQuoteBar.CurrentInterestRate value={quoteData.currentCreditingRate} />
          <HeaderQuoteBar.AnnualPercentageYield value={quoteData.annualPercentageYield} />
        </HeaderQuoteBar>
      </PageHeader>
      <PageMain>
        <SectionDivider
          labelText={sectionDividerOptions.performance.label}
          id={sectionDividerOptions.performance.id}
          isDynamicGreetingShown={showDynamicGreeting}
          dynamicGreetingParticipantHoldings={participantHoldingsData}
        >
          <Row>
            <Col>
              <HistoricalRatesOfReturn
                chartName={'Historical Net Rates Returns'}
                hideSwitch={true}
                selectedPeriod={'Monthly'}
                hideCumulativeReturns={true}
              />
            </Col>
          </Row>
        </SectionDivider>
        <SectionDivider
          labelText={sectionDividerOptions.characteristics.label}
          id={sectionDividerOptions.characteristics.id}
        >
          <Row>
            <Col>
              <InvestmentStrategy heading="Investment Description">
                {store.investmentStrategy}
              </InvestmentStrategy>
            </Col>
          </Row>
        </SectionDivider>
        <SectionDivider
          labelText={sectionDividerOptions.resources.label}
          id={sectionDividerOptions.resources.id}
        >
          <CardResourceContainer>
            <CardResource.SimpleLink
              bodyText={`Terms and\nConditions`}
              data-analytics-componenttype="column-component"
              data-analytics-id="COL_Regulatory"
              data-analytics-section="component"
              href="https://www.tiaa.org/public/pdf/prospectuses/BanksTerms.pdf"
              bottomLink="Read now"
              iconVariant="Document"
              titleText="Regulatory"
            />
          </CardResourceContainer>
          <p {...className('disclaimer-text', 'text-dark', 'mt-5')}>
            The current Retirement Reserves Bank is EverBank, National Association.
          </p>
        </SectionDivider>
        <FooterDisclosures />
        <div {...className('admaster-number', 'd-print-none')}>X-3240728P-Q0923W</div>
        <DisclosurePrint disclosureList={disclosureList} admasterNumber="X-3240728P-Q0923W" />
      </PageMain>
      <PageSideRail />
    </div>
  );
};

export default FdicInsuredBankProduct;
